import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FormButtons, FormRow, FileUpload, Loading } from '../controls';

const FAQSchema = Yup.object().shape({
  faqName: Yup.string().required('FAQ name is required'),
  faqDescription: Yup.string().required('Description is required'),
});

export function FAQForm({
  faq,
  onFileUpload,
  loading,
  handleSave,
  handleRemove,
  onFileDelete,
}) {
  const defaultValues = {
    faqName: faq.faqName || '',
    faqDescription: faq.faqDescription || '',
    priority: faq.priority || 0,
  };

  const fileList = [];

  if (faq.photoURL) {
    fileList.push({
      uid: '-1',
      name: faq.faqPhoto,
      url: faq.photoURL,
      status: 'done',
    });
  }

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={defaultValues}
        onSubmit={handleSave}
        validationSchema={FAQSchema}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <div className="flex">
              <div className="flex w-3/4 flex-wrap items-center p-4">
                <FormRow label="FAQ Name" errorName="faqName">
                  <Field type="text" name="faqName" placeholder="Name" />
                </FormRow>
                <FormRow label="Full Screen">
                  <input
                    type="checkbox"
                    className="h-5 w-10 cursor-pointer rounded-full accent-[var(--festy-sky-blue)]"
                    checked={Number(values.priority) === 1}
                    onChange={(e) =>
                      setFieldValue('priority', e.target.checked ? 1 : 0)
                    }
                    aria-label="Full screen FAQ"
                  />
                </FormRow>
              </div>
              <div className="w-1/4 p-4">
                <FormRow>
                  <div className="w-full">
                    <FileUpload
                      fileList={fileList}
                      onFileUpload={onFileUpload}
                      onFileDelete={onFileDelete}
                    />
                  </div>
                </FormRow>
              </div>
            </div>
            <FormRow label="Description" errorName="faqDescription">
              <Field
                component="textarea"
                name="faqDescription"
                placeholder="FAQ Description..."
              />
            </FormRow>
            {loading && <Loading />}
            <FormButtons
              showDelete={faq.faqId}
              title="FAQ"
              onDelete={handleRemove}
            />
          </Form>
        )}
      </Formik>
    </>
  );
}
